import React from 'react';
import compact from 'lodash/compact';
import { FormattedMessage } from 'react-intl';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { ChevronLink } from '@bibliocommons/base-links';

function getDirectionsLink(address) {
  const destinationQuery = compact([
    address.get('number'),
    address.get('street'),
    address.get('city'),
    address.get('state')
  ]).join('+');

  return `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(destinationQuery)}`;
}

export default function LocationAddress({ location }) {
  const address = location.get('address');
  const addressLine1 = `${address.get('number', '')} ${address.get('street', '')}`.trim();
  const addressLine2 = `${address.get('city', '')}, ${address.get('state', '')} ${address.get('zip', '')}`.trim();

  return (
    <div className="cp-location-address">
      {addressLine1 && <div>{addressLine1}</div>}
      {addressLine2 && <div>{addressLine2}</div>}
      <ChevronLink className="get-directions" href={getDirectionsLink(address)} dataKey="directions-link">
        <FormattedMessage id="get_directions" />
      </ChevronLink>
    </div>
  );
}

LocationAddress.propTypes = {
  location: ImmutablePropTypes.map.isRequired
};
